import Query from '../../../components/Report';

const query = new Query('search-summary-timeline');

export default query;
